export const WeightUnitToggle = ({ unit, onChange, testIdPrefix = 'weight-unit' }) => (
  <div className="inline-flex rounded-full border border-white/15 bg-white/[0.03] p-0.5" role="group" aria-label="Weight unit">
    {['lb', 'kg'].map((u) => (
      <button
        type="button" key={u} onClick={() => onChange(u)}
        className={`px-3 py-1 rounded-full text-xs font-semibold uppercase transition-colors ${u === unit ? 'bg-primary text-black' : 'text-white/60 hover:text-white'}`}
        data-testid={`${testIdPrefix}-${u}`}
      >
        {u}
      </button>
    ))}
  </div>
);

export default WeightUnitToggle;
